<template>
  <q-card
    bordered
    class="q-mt-md q-pa-sm shadow-1"
    style="width: 450px; max-width: 90vw"
  >
    <q-card-section class="row items-center q-pb-none text-green-vito">
      <div class="text-h6">{{ cardTitle }}</div>
      <q-space />
      <q-btn icon="close" flat round dense v-close-popup />
    </q-card-section>
    <q-card-section>
      <q-form class="q-gutter-y-md">
        <q-input
          ref="name"
          square
          filled
          clearable
          v-model="form.name"
          :label="$t('label.name')"
          :hint="$t('hint.minchar', { chars: 3 })"
          lazy-rules
          :rules="[required, short]"
        >
          <template v-slot:prepend>
            <q-icon name="person" />
          </template>
        </q-input>
        <q-input
          ref="email"
          square
          filled
          clearable
          v-model="form.email"
          :hint="$t('hint.emailFormat')"
          type="email"
          :label="$t('label.email')"
          lazy-rules
          :rules="[required, isEmail]"
        >
          <template v-slot:prepend>
            <q-icon name="email" />
          </template>
        </q-input>

        <q-select
          filled
          v-model="form.roles"
          multiple
          :options="roleOptions"
          use-chips
          stack-label
          map-options
          emit-value
          :label="$t('label.roles')"
          hint=""
          ><template v-slot:prepend>
            <q-icon name="view_week" />
          </template>
        </q-select>

        <q-select
          v-model="form.language"
          :options="localeOptions"
          :label="$t('label.language')"
          filled
          borderless
          square
          emit-value
          hint=""
          map-options
          ref="lang"
        >
          <template v-slot:prepend>
            <q-icon name="flag" />
          </template>
        </q-select>

        <q-input
          ref="password"
          autocomplete="new-password"
          square
          filled
          clearable
          v-model="form.password"
          :type="passwordFieldType"
          :label="$t('label.password')"
          lazy-rules
          :rules="passwordRules"
          :hint="passwordHint"
        >
          <template v-slot:prepend>
            <q-icon name="lock" />
          </template>
          <template v-slot:append>
            <q-icon
              :name="visibilityIcon"
              @click="switchVisibility"
              class="cursor-pointer q-mt-xs"
            />
          </template>
        </q-input>
        <q-input
          ref="passwordVerification"
          square
          filled
          clearable
          v-model="form.passwordVerification"
          :type="passwordFieldType"
          :label="$t('label.repeatPassword')"
          lazy-rules
          :disable="!form.password"
          :rules="[passwordVerificationValidator]"
          :hint="$t('hint.repeatPassword')"
        >
          <template v-slot:prepend>
            <q-icon name="lock" />
          </template>
          <template v-slot:append>
            <q-icon
              :name="visibilityIcon"
              @click="switchVisibility"
              class="cursor-pointer q-mt-xs"
            />
          </template>
        </q-input>
        <q-toggle
          ref="isActive"
          v-model="form.isActive"
          :label="form.isActive == true ? $t('active') : 'Inactif'"
          color="green-vito"
        >
        </q-toggle>
      </q-form>
    </q-card-section>
    <q-card-section>
      <div v-if="errorMessage" class="text-red-vito text-center">
        <strong>{{ errorMessage }}</strong>
      </div>
    </q-card-section>

    <q-card-actions class="q-px-md justify-end">
      <q-btn
        unelevated
        size="md"
        class="text-green-vito"
        :label="$t('button.cancel')"
        @click="$emit('refresh')"
      />
      <q-btn
        unelevated
        size="md"
        class="bg-blue-btz text-white"
        :label="$t('button.save')"
        @click="handleSave"
      />
    </q-card-actions>
  </q-card>
</template>

<script>
import UserApi from "../../apis/User";
import { useI18n } from "vue-i18n";

export default {
  props: ["user", "action"],
  setup() {
    const { locale } = useI18n({ useScope: "global" });
    return {
      locale,
      localeOptions: [
        { value: "de", label: "Deutsch" },
        { value: "fr", label: "Français" },
        { value: "en-US", label: "English" },
      ],
    };
  },
  data: () => {
    return {
      form: {
        id: 0,
        name: "",
        password: "",
        passwordVerification: "",
        roles: [],
        email: "",
        language: "en-US",
        isActive: true,
      },
      passwordFieldType: "password",
      visibilityIcon: "visibility",
      errorMessage: null,
    };
  },
  async mounted() {
    this.form = this.user;
    //console.log("user", this.user);
  },
  methods: {
    async handleSave() {
      this.$refs.email.validate();
      this.$refs.name.validate();
      this.$refs.password.validate();
      this.$refs.passwordVerification.validate();
      if (
        this.$refs.name.hasError ||
        this.$refs.email.hasError ||
        this.$refs.password.hasError ||
        this.$refs.passwordVerification.hasError
      ) {
        this.$emit("shake");
        // form has error
      } else {
        //console.log(this.action);
        try {
          this.errorMessage = null;
          let payload = {
            name: this.form.name,
            email: this.form.email,
            language: this.form.language,
            roles: this.form.roles,
            password: null,
            isActive: this.form.isActive,
          };
          if (
            this.form.password &&
            this.form.password.length &&
            this.form.password == this.form.passwordVerification
          ) {
            payload.password = this.form.password;
          }
          const saveResponse =
            this.action == "edit"
              ? await UserApi.adminSave(this.form.id, payload)
              : await UserApi.adminCreate(payload);
          this.$q.notify({
            type: "positive",
            message: saveResponse.data.message
              ? this.$t(saveResponse.data.message)
              : saveResponse.data.error
              ? saveResponse.data.error
              : "Done",
          });
          //this.$emit("refresh");
        } catch (error) {
          const message = error.response
            ? error.response.data.message
            : error.message;
          this.errorMessage = message;
          this.$q.notify({
            type: "negative",
            message: message,
          });
          //console.error(message);
        }
      }
    },
    required(val) {
      return (val && val.length > 0) || this.$t("validation.required");
    },
    short(val) {
      return (
        (val && val.length > 2) || this.$t("validation.minchar", { chars: 3 })
      );
    },
    passwordValidator(val) {
      return val && val.length
        ? (val && val.length > 5) || this.$t("validation.minchar", { chars: 6 })
        : true;
    },
    passwordVerificationValidator(val) {
      return this.form.password && this.form.password.length
        ? val === this.form.password || this.$t("validation.repeatPassword")
        : true;
    },
    isEmail(val) {
      const emailPattern =
        /^(?=[a-zA-Z0-9@._%+-]{6,254}$)[a-zA-Z0-9._%+-]{1,64}@(?:[a-zA-Z0-9-]{1,63}\.){1,8}[a-zA-Z]{2,63}$/;
      return emailPattern.test(val) || this.$t("validation.isEmail");
    },

    switchVisibility() {
      this.visibility = !this.visibility;
      this.passwordFieldType = this.visibility ? "text" : "password";
      this.visibilityIcon = this.visibility ? "visibility_off" : "visibility";
    },
  },
  computed: {
    cardTitle() {
      return this.action == "edit"
        ? this.$t("title.editUser")
        : this.$t("title.addUser");
    },
    passwordRules() {
      //console.log(this.action);
      return this.action == "create"
        ? [this.passwordValidator, this.required]
        : [this.passwordValidator];
    },
    passwordHint() {
      return (
        this.$t("hint.minchar", { chars: 6 }) +
        (this.action == "create" ? ", " + this.$t("hint.required") : "")
      );
    },
    roleOptions() {
      return [
        { label: this.$t("label.role.user"), value: "user" },
        { label: this.$t("label.role.admin"), value: "admin" },
        { label: this.$t("label.role.super"), value: "super" },
      ];
    },
  },
};
</script>
